<template>
  <div ref="self" class="factbox card floatright" :class="{ 'text-center': text === 'center' }">
    <img v-if="props.ornamentTop" src="/img/ornament.png" class="ornament" />
    <MDCSlot name="default" />
    <img v-if="ornamentBottom" src="/img/ornament-inverted.png" class="ornament" />
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  left?: boolean
  text?: 'center' | null
  ornamentTop?: boolean
  ornamentBottom?: boolean
}>()
</script>

<style scoped lang="postcss">
.factbox {
  width: 100%;
  container: factbox / inline-size;
  padding: 1em 0.5em;

  &.left {
    float: left;
    margin-right: 1.5em;
    margin-left: 0;
  }

  &:empty {
    display: none;
  }

  .ornament {
    max-width: 100%;
    margin-bottom: 10px;
  }

  @media screen and (max-width: 600px) {
    max-width: 100%;
    margin: 0.5em 0 1em;
  }
}
</style>

<style lang="postcss">
.factbox {
  :first-child {
    margin-top: 0;
  }

  :last-child {
    margin-bottom: 0 !important;
  }

  > p {
    margin: 0 0.5em 0.5em;
  }

  h3,
  h4 {
    text-align: center;
    border-bottom: 2px solid var(--primary);
    margin: 0 0 0.5em;
  }

  h5,
  h6 {
    text-align: center;
    margin: 0.5em 0;
  }

  .icon {
    margin: auto;
    display: block;
    margin-bottom: 0.5rem;
  }

  img {
    width: 100%;
  }

  table {
    display: table;
    width: calc(100%);
    padding: 0;
    margin-bottom: 0.5em;

    tr:nth-of-type(2n + 1) {
      background: var(--background);
    }

    td,
    th {
      padding: 0.25em 0.5em;
    }
  }

  &.text-center,
  &.text-center > p {
    text-align: center;
  }

  > p > .elvish,
  > p > .insular,
  > p > .runes {
    display: block;
    text-align: center;
  }
}
</style>
